import { useEffect } from "react";

const SITE = "https://matrivon.com";

// Lightweight SEO: sets title, meta description, canonical and optional JSON-LD.
export const Seo = ({ title, description, path, jsonLd, image, ogType, articleMeta }) => {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const ogImage = image ? (image.startsWith("http") ? image : `${SITE}${image}`) : `${SITE}/logo.png`;
    setMeta("description", description);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", ogType || "website", "property");
    setMeta("og:image", ogImage, "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    setMeta("twitter:image", ogImage);
    if (path) setMeta("og:url", `${SITE}${path}`, "property");
    if (articleMeta) {
      setMeta("article:published_time", articleMeta.published, "property");
      setMeta("article:modified_time", articleMeta.modified, "property");
      setMeta("article:author", articleMeta.author, "property");
      setMeta("article:section", articleMeta.section, "property");
    }

    if (path) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", `${SITE}${path}`);
    }

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo", "page");
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      if (script) script.remove();
    };
  }, [title, description, path, jsonLd, image, ogType, articleMeta]);

  return null;
};
